import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import clsx from "clsx";
import { Button } from "./Button";
export function FeedbackWithCrisp(_param) {
    var children = _param.children, useDefaultComponent = _param.useDefaultComponent, _className = _param.className, className = _className === void 0 ? "" : _className, rest = _object_without_properties(_param, [
        "children",
        "useDefaultComponent",
        "className"
    ]);
    if (useDefaultComponent) {
        children = /*#__PURE__*/ _jsx(Button, {
            ghost: true,
            children: "Feedback"
        });
    }
    return /*#__PURE__*/ _jsx("div", _object_spread_props(_object_spread({
        onClick: function() {
            if (typeof $crisp === "undefined") {
                console.warn("FeedbackWithCrisp has not found $crisp variable");
                return;
            }
            $crisp.push([
                "set",
                "message:text",
                [
                    "Hi! I have some feedback: "
                ], 
            ]);
            // $crisp.push(["set", "session:data", [[["user-bill-amount", "$200"]]]]);
            $crisp.push([
                "set",
                "session:event",
                [
                    [
                        [
                            "feedback"
                        ]
                    ]
                ]
            ]);
            $crisp.push([
                "do",
                "chat:open"
            ]);
        },
        className: clsx("", className)
    }, rest), {
        children: children
    }));
}
